var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.464,
    height: 14.967,
    viewBox: "0 0 19.464 14.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#70db7e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.626,24.25a1.154,1.154,0,0,1,0-1.608l.239-.239a1.154,1.154,0,0,1,1.608,0l4.171,4.171L22.592,15.626a1.154,1.154,0,0,1,1.608,0l.239.239a1.154,1.154,0,0,1,0,1.608L11.643,30.267Z",
    transform: "translate(-5.3 -15.3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick_icon.6b5c48b55012b1b49e2b4f38b5ba9b94.svg";
export { ForwardRef as ReactComponent };